import { useMutation, useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";

import { Button } from "../../../../components/ui";
import { LIST_TYPES } from "../../../../constants/listTypes";
import { CREATE_LIST } from "../../../../graphql/mutation/List";
import { FETCH_LISTS as fetchLists } from "../../../../graphql/query/List";
import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../graphql/query/ListItems";

const getNumericListId = value => {
  const parsedValue = +value;
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

const AddInstanceToSelectList = props => {
  const { closeModal, instance, listId, workingListId } = props || {};
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const listIdFromUrl = queryParams.get("listId");
  const workingListIdFromUrl = queryParams.get("workingListId");
  const { data: { lists: { edges = [] } = {} } = {} } = useQuery(fetchLists(), {
    variables: {
      input: { typeId: LIST_TYPES.INSTANCE_WORKING },
    },
    fetchPolicy: "network-only",
  });
  const fallbackWorkingListId = getNumericListId(edges?.[0]?.id);
  const targetListId =
    getNumericListId(listId) ||
    getNumericListId(listIdFromUrl) ||
    getNumericListId(workingListId) ||
    getNumericListId(workingListIdFromUrl) ||
    fallbackWorkingListId;
  const [createList, { loading }] = useMutation(CREATE_LIST(), {
    refetchQueries: [
      {
        query: fetchLists(),
        variables: { input: {} },
        fetchPolicy: "network-only",
      },
      {
        query: fetchListItems(),
        variables: { input: {} },
        fetchPolicy: "network-only",
      },
    ],
    awaitRefetchQueries: true,
  });

  const handleClick = () => {
    if (!targetListId || !instance?.id) {
      return;
    }

    createList({
      variables: {
        input: {
          listId: targetListId,
          listItemIds: [instance.id],
        },
      },
    }).then(resp => {
      const { data: { createList: { success } = {} } = {} } = resp;

      if (success) {
        closeModal();
      }
    });
  };

  return (
    <div className="flex flex-col">
      <div>
        <Button
          action="default"
          className="mr-4"
          label="Cancel"
          onClick={() => {
            closeModal();
          }}
        />
        <Button
          label={loading ? "Adding" : "Add"}
          disabled={loading || !targetListId || !instance?.id}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default AddInstanceToSelectList;
